import isEmpty from '../../utility/isEmpty'
import { defaultObj } from './state'

export default {
  openTooltip (state, data) {
    if (!isEmpty(data.handlers)) {
      state.handlers = data.handlers
    }

    if (!isEmpty(data.props)) {
      state.props = data.props
    }
  },

  reset (state) {
    state = Object.assign(state, defaultObj)
  }
}
